module.exports = __webpack_public_path__ + "static/media/parceiro(8).659532f8.png";